(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition(require('../../public/strings/strings.js'));

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.linksSharedObservationTypes = definition(RivalIQ.strings);

    }

    function definition(strings) {

        return {
            ownedContentRatio: {
                id: 'ownedContentRatio',
                name: 'Owned vs. Curated URLs',
                description: strings.links_shared_observation_owned_content_ratio_description,
                link: {
                    props: {
                        instanceId: 'links-posted-owned-vs-curated',
                        orderBy: 2
                    },
                    html: 'View comparison <span class="fa fa-angle-double-right"></span>'
                }
            },
            multipleShares: {
                id: 'multipleShares',
                name: 'Highly Posted URL',
                description: strings.links_shared_observation_multiple_shares_description,
                link: {
                    propsFcn: function (data) {
                        return {
                            instanceId: 'shared-urls-by-company',
                            rowExpansions: `(id:${data.companyId})`
                        };
                    },
                    html: 'View URLs <span class="fa fa-angle-double-right"></span>'
                }
            },
            popularDomains: {
                id: 'popularDomains',
                name: 'Popular Domains',
                description: strings.links_shared_observation_popular_domains_description,
                link: {
                    props: {
                        instanceId: 'shared-domains'
                    },
                    html: 'View popular domains <span class="fa fa-angle-double-right"></span>'
                }
            },
            distinctUrls: {
                id: 'distinctUrls',
                name: 'Unique URLs',
                description: strings.links_shared_observation_distinct_urls_description,
                link: {
                    props: {
                        instanceId: 'shared-urls-by-company'
                    },
                    html: 'View comparison <span class="fa fa-angle-double-right"></span>'
                }
            }
        };
    }
})();
